import { Link, useNavigate } from "react-router-dom";
import { LogOut, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AdminHeader({ title = "Admin Dashboard" }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = () => {
    logout();
    navigate("/admin/login");
  };

  return (
    <header
      data-testid="admin-header"
      className="sticky top-0 z-40 border-b border-white/10"
      style={{
        background: "linear-gradient(180deg, #0b0b0d 0%, #050506 100%)",
      }}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between h-16 px-4 sm:px-6">
        <Link to="/admin/dashboard" className="flex items-center gap-3 text-white">
          <div className="h-9 w-9 rounded-md bg-white flex items-center justify-center p-0.5">
            <img
              src="https://customer-assets-jt897jd0.emergentagent.net/job_ref-connect-app/artifacts/02ztij1f_logo.png"
              alt="Unique Deal India"
              className="h-full w-full object-contain"
            />
          </div>
          <div className="leading-tight">
            <div
              className="font-extrabold text-emerald-400 tracking-tight text-lg"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              {title}
            </div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-white/60">
              Unique Deal India · Control Panel
            </div>
          </div>
        </Link>
        <div className="flex items-center gap-3">
          <div className="hidden sm:flex items-center gap-2 text-xs text-white/70 border border-white/10 rounded-full px-3 py-1">
            <ShieldCheck size={14} className="text-emerald-400" />
            {user?.name} · {user?.role}
          </div>
          <button
            data-testid="admin-logout-btn"
            onClick={doLogout}
            className="inline-flex items-center gap-2 text-sm border border-emerald-400/40 text-emerald-400 hover:bg-emerald-400 hover:text-black rounded-lg px-3 py-1.5 font-semibold transition-colors"
          >
            <LogOut size={14} /> Sign out
          </button>
        </div>
      </div>
    </header>
  );
}
